<template>
  <div id="checkout" class="below-header">
    <div v-if="!checkoutCompleted" class="container-fluid px-4 px-md-5 mt-4 mb-5">

      <!-- Purchase Mode Toggle -->
      <div class="d-flex justify-content-center my-4">
        <TogglePills 
          v-model="purchaseMode"
          :options="purchaseModeOptions"
          :class="darkMode ? 'bg-dark' : 'bg-white'"
          size="lg"
        />
      </div>

      <div class="plans-header my-4 text-center">
        <h2>{{ $t(`billing.plans.${purchaseMode}.title`) }}</h2>
        <p class="plans-header__subtitle" style="max-width: 600px; margin: 0 auto;">{{ $t(`billing.plans.${purchaseMode}.subtitle`) }}</p>
      </div>
      <!-- Subscription Unlock -->
      <div v-if="purchaseMode === 'subscription'">

        <subscription-unlock />
      </div>
      <!-- Single Unlock -->
      <div v-else-if="purchaseMode === 'single'">

        <single-unlock />
      </div>
      <!-- FAQ Button -->
      <div v-if="loaded" class="d-flex justify-content-center mt-4 mb-5 pb-4 gap-20">
        <b-button v-if="purchaseMode === 'subscription'" variant="primary" @click="createCustomerPortal" :disabled="stripeMixin.loading">
          {{ $t('billing.payment.viewProfile') }}
        </b-button>
        <b-button 
          variant="full-white" 
          class="faq-link d-flex align-items-center"
          @click="$store.commit('ui/OPEN_SIDE_SHEET', SidebarVariants.CheckoutFaqSidebar)"
        >
          <span class="icon-help mr-2" style="font-size: 20px;"></span>
          Have questions? Check our FAQ
        </b-button>
      </div>

      <CheckoutFaqSidebar />

    </div>
    <ThankYouPage v-else/>

  </div>

</template>

<script>
import {mapState} from "vuex";
import SingleUnlock from "../../components/billing/cart/SingleUnlock";
import ThankYouPage from "../../components/billing/ThankYouPage.vue";
import AnalyticsMixin from "@/mixins/AnalyticsMixin";
import ServerContentMixin from "@/mixins/ServerContentMixin";
import SubscriptionUnlock from "@/components/billing/cart/SubscriptionUnlock.vue";
import TogglePills from "@/components/elements/TogglePills.vue";
import CheckoutFaqSidebar from "@/components/structure/sidebars/CheckoutFaqSidebar.vue";
import { SidebarVariants } from "@/utils/localStorage";
import StripeMixin from "@/mixins/StripeMixin";

export default{
  mixins: [AnalyticsMixin, ServerContentMixin, StripeMixin],
  components: {ThankYouPage, SingleUnlock, SubscriptionUnlock, TogglePills, CheckoutFaqSidebar},

  computed:{
    ...mapState({
      checkout_type: state => state.checkout.checkout_type,
      products: state => state.checkout.products,
      single_cart_items: state => state.checkout.single_cart_items,
      lastVisitedChart: state => state.ui.lastVisitedChart,
      checkoutCompleted: state => state.checkout.checkoutCompleted,
      checkoutContent: state => state.ui.clientContent.checkout
    }),
    purchaseModeOptions() {
      return [
        { value: 'subscription', label: this.$t('billing.checkout.tabs.subscription') },
        { value: 'single', label: `${this.$t('billing.checkout.tabs.unlock')} (${this.single_cart_items.length})` }
      ];
    }
  },
  beforeDestroy() {
    this.$store.commit('checkout/SET_CHECKOUT_COMPLETED', false);
    this.$store.commit('checkout/SET_COMPLETED_CHECKOUT_KIND', null);
  },
  watch:{
    purchaseMode(val){
      if(!this.loaded) return;
      this.$store.commit('checkout/setCheckoutType', val === 'subscription' ? 1 : 0);
    },
  },
  data(){
    return{
      loaded: false,
      thankYouPage: false,
      purchaseMode: 'subscription',
      SidebarVariants,
    }
  },

  // On creation, we want to reload all checkout-specific data.
  created(){
    this.$store.dispatch('checkout/loadProducts');
    this.$store.dispatch('account/getUserSubscriptions');
    this.$store.dispatch('account/getUserUnlockedCharts');
    this.facebookEvent('InitiateCheckout');
    this.getClientContent(); // refresh our cache, just in case.

  },
  mounted(){
    if (this.checkout_type === this.CheckoutTypes.SINGLE || this.checkout_type === this.CheckoutTypes.SUBSCRIPTION) { 
      this.purchaseMode = this.checkout_type;
    } else {
      this.purchaseMode = this.CheckoutTypes.SUBSCRIPTION;
    }

    if (this.$route.query.status === 'success') {
      this.$store.commit('checkout/SET_CHECKOUT_COMPLETED', true);
      this.$store.commit('checkout/SET_COMPLETED_CHECKOUT_KIND', this.$route.query.kind);
    }

    this.loaded = true;
  },
  methods: {
    getClientContent() {
      this.axios.get('/content/client-content').then( res => {
        this.$store.commit('ui/SET_CLIENT_CONTENT', res.data);
      })
    }
  }
}
</script>
